// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-28De-";
var _4 = "header-3hjez";
var _5 = "desc-12nwm";
var _6 = "buttons-RTIA0";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "header", _5 as "desc", _6 as "buttons" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "header": _4, "desc": _5, "buttons": _6 }
